import React from "react";
import { Select } from "antd";


export default class CompanyTypeSelector extends React.Component {
  state = {
    value: this.props.value
  };

  onSelectValueChanged = newValue => {
    this.setState(
      {
        value: newValue
      },
      function() {
        this.fireChanged();
      }
    );
  };

  fireChanged = () => {
    this.props.onChange(this.state.value);
  };

  render() {
    const companyTypes = this.props.companyTypes;
    return (
      <div>
        <Select
            style={{ width: '100%' }}
          placeholder={this.props.placeholder}
          optionFilterProp="children"
          onChange={this.onSelectValueChanged}
          value={this.state.value}
          defaultValue={this.props.value}
        >
          {companyTypes.map((companyType, idx) => {
            return (
              <Select.Option value={companyType.code} key={companyType.code}>
                {companyType.value}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    );
  }
}
